import React from 'react';
import { Grid, Table, TableHead, TableCell, TableRow, Paper, Button, TableBody,
		 Dialog, DialogTitle, DialogContent, TextField, DialogActions } from '@material-ui/core';
import { withSnackbar } from 'notistack';
import isEmpty from 'validator/lib/isEmpty';
import LazyBox from '../../../web/components/LazyBox';

//services
import SegmentoAPI from '../../../services/api/Segmento';

class NovoSegmento extends React.Component {
	state = {
	  open: false,

	  nome:'',

	  isNome:false,
	};

	handleClickOpen = () => {
	  this.setState({ open: true });
	};

	handleClose = () => {
	  this.setState({ open: false,
					  nome:'', });
	};

	submit = (ev) => {
		const { refreshSegmentos, enqueueSnackbar } = this.props;
		ev.preventDefault();
		const { nome } = this.state;
		if( isEmpty(nome) ){
			this.setState({isNome: true}, () => enqueueSnackbar('Preencha o campo de nome.'));
			return;
		}

		let forms = {
			nome:nome
		}

		SegmentoAPI.cadastro(forms)
				   .then(res => {
						res.json().then(res => {
							if(res.msg){
								this.props.enqueueSnackbar(res.msg);
								return;
							}
							this.setState({open:false}, () => refreshSegmentos(enqueueSnackbar('Cadastro efetuado com sucesso!')))
						})
					}).catch(() => enqueueSnackbar('Não foi possivel efetuar o cadastro tente novamente mais tarde.'))

	}

	render() {
		const { nome, isNome } = this.state;
	  return (
		<div style={{display:'inline'}} >
		  <Button variant="outlined" onClick={this.handleClickOpen} >Novo segmento</Button>
			<Dialog
				open={this.state.open}
				onClose={this.handleClose}
				fullWidth >
				<form onSubmit={this.submit} >
					<DialogTitle id="form-dialog-title">Cadastro</DialogTitle>
					<DialogContent>
						<Grid container spacing={16} direction="column" >
									<Grid item md={12} >
										<TextField label="Nome"
												onChange={e => this.setState({ nome: e.target.value })}
												value={nome}
												margin="normal"
												variant="outlined"
												error={isNome}
												fullWidth />
									</Grid>
						</Grid>
					</DialogContent>
					<DialogActions>
					<Button onClick={this.handleClose} color="secondary">
						Cancelar
					</Button>
					<Button type="submit" color="primary">
						Cadastrar
					</Button>
					</DialogActions>
				</form>
		  </Dialog>
		</div>
	  );
	}
  }

class EditarSegmento extends React.Component {
	state = {
	  open: false,

	  id: this.props.segmento.id,
	  nome: this.props.segmento.nome,

	  isNome:false,
	};

	handleClickOpen = () => {
	  this.setState({ open: true });
	};

	handleClose = () => {
	  this.setState({ open: false });
	};

	submit = (ev) => {
		const { refreshSegmentos, enqueueSnackbar } = this.props;
		ev.preventDefault();
		const { nome } = this.state;
		if( isEmpty(nome) ){
			this.setState({isNome: true},() => enqueueSnackbar('Preencha os campos de nome.'));
			return;
		}

		let forms = {
			nome:nome,
		}

		SegmentoAPI.editar(forms, this.props.segmento.id)
				   .then(res => {
						res.json().then(res => {
							if(res.msg){
								this.props.enqueueSnackbar(res.msg);
								return;
							}
							this.setState({open:false}, () => refreshSegmentos(enqueueSnackbar('Alteração efetuada com sucesso!')) )
						})
					}).catch(() => enqueueSnackbar('Não foi possivel efetuar a alteração tente novamente mais tarde.'))

	}

	render() {
		const { nome, isNome } = this.state;
	  return (
		<div style={{display:'inline'}} >
		  <Button variant="outlined" onClick={this.handleClickOpen} > Editar </Button>
		  <Dialog
			open={this.state.open}
			onClose={this.handleClose}
			aria-labelledby="form-dialog-title"
			fullWidth
		  >
		  	<form onSubmit={this.submit} >
				<DialogTitle id="form-dialog-title">Editar</DialogTitle>
				<DialogContent>
					<Grid container spacing={16} direction="column" >
								<Grid item md={12} >
									<TextField label="Nome"
											onChange={e => this.setState({ nome: e.target.value })}
											value={nome}
											margin="normal"
											variant="outlined"
											error={isNome}
											fullWidth />
								</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
				<Button onClick={this.handleClose} color="secondary">
					Cancelar
				</Button>
				<Button type="submit" color="primary">
					Salvar
				</Button>
				</DialogActions>
			</form>
		  </Dialog>
		</div>
	  );
	}
  }

class Segmentos extends React.Component {
	state = {
		page:0,
		rowsPerPage: 5,
		segmentos:[],
		loading: true,
	}
	refreshSegmentos = () => {
		const { enqueueSnackbar } = this.props;
		SegmentoAPI.lista()
				.then(res => {
					res.json().then(res => {
						if (res.msg) {
							this.setState({ loading: false }, () => enqueueSnackbar(res.msg));
							return;
						}
						this.setState({ segmentos: res, loading: false })
						return;
					})
				}).catch(() => this.setState({ loading: false }, () => enqueueSnackbar('Não foi possivel carregar a lista')))
	}

	excluirSegmento = (id) => {
		const { enqueueSnackbar } = this.props;
		SegmentoAPI.excluir(id)
				.then(res => {
					res.json().then(res => {
						if (res.msg) {
							enqueueSnackbar(res.msg);
							return;
						}
						this.refreshSegmentos();
						enqueueSnackbar("Segmento excluido com sucesso!");
					})
				}).catch(() => this.setState({ loading: false }, () => enqueueSnackbar('Não foi possivel excluir o Segmento')))
	}

	componentDidMount(){
		this.refreshSegmentos();
	}
    render() {
		const { segmentos, loading } = this.state;
		const { enqueueSnackbar } = this.props;
        return  (
				<div className="app_control__content_padding" >
					<LazyBox height="80vh" loading={loading} >
						<Grid container spacing={32} >
							<Grid item xs={12} >
								<NovoSegmento enqueueSnackbar={enqueueSnackbar} refreshSegmentos={this.refreshSegmentos} />
							</Grid>
							<Grid item xs={12} >
								<Paper elevation={0} >
									<Table>
										<TableHead>
											<TableRow>
												<TableCell>Nome</TableCell>
												<TableCell>Ações</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{segmentos.map((s,k) => <TableRow key={k} >
												<TableCell>{s.nome}</TableCell>
												<TableCell className="buttons_intable" >
													<EditarSegmento segmento={s} enqueueSnackbar={enqueueSnackbar} refreshSegmentos={this.refreshSegmentos} />
													<Button variant="outlined" onClick={() => this.excluirSegmento(s.id)} > Excluir </Button>
												</TableCell>
											</TableRow>)}
										</TableBody>
									</Table>
									{/* <TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={segmentos.length}
										rowsPerPage={rowsPerPage}
										page={page}
										backIconButtonProps={{
											'aria-label': 'Anterior',
										}}
										nextIconButtonProps={{
											'aria-label': 'Próximo',
										}}
										labelDisplayedRows={({from,to,count}) => `Exibindo de ${from} à ${to} de ${count}`}
										labelRowsPerPage={`Registros por página`}
										onChangePage={(event,pagina) => this.setState({ page: pagina })}
										onChangeRowsPerPage={(event,qtd) => this.setState({ rowsPerPage: Number(qtd.key) })}
									/> */}
								</Paper>
							</Grid>
						</Grid>
					</LazyBox>
				</div>
        );
    }
}


export default withSnackbar(Segmentos);



// WEBPACK FOOTER //
// ./src/painel/pages/segmentos/index.js